import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './main.routes';

export class MainController {

    awesomeThings = [];
    newThing = '';

    /*@ngInject*/
    constructor($http, lookup) {
        this.$http = $http;
        this.lookup = lookup;
    }

    $onInit() {

        function initTheme() {
            var transparent = true;
            var big_image;

            var transparentDemo = true;
            var fixedTop = false;

            var navbar_initialized,
                backgroundOrange = false,
                toggle_initialized = false;

            var nowuiKit,
                $navbar,
                $toggle,
                scroll_distance,
                oVal;

            $(document).ready(function() {
                //  Activate the Tooltips
                $('[data-bs-toggle="tooltip"], [rel="tooltip"]').tooltip();

                //    Activate bootstrap-select
                if ($(".selectpicker").length != 0) {
                    $(".selectpicker").selectpicker({
                        iconBase: "now-ui-icons",
                        tickIcon: "ui-1_check"
                    });
                };

                if ($(window).width() >= 768) {
                    big_image = $('.header[data-parallax="true"]');
                    if (big_image.length != 0) {
                        $(window).on('scroll', nowuiKit.checkScrollForParallax);
                    }
                }

                // Activate Popovers and set color for popovers
                $('[data-bs-toggle="popover"]').each(function() {
                    color_class = $(this).data('color');
                    $(this).popover({
                        template: '<div class="popover popover-' + color_class + '" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>'
                    });
                });

                //Activate tags
                // we style the badges with our colors
                var tagClass = $('.tagsinput').data('color');

                if ($(".tagsinput").length != 0) {
                    $('.tagsinput').tagsinput();
                }

                $('.bootstrap-tagsinput').addClass('text-bg-' + tagClass + '');

                // Activate the image for the navbar-collapse
                nowuiKit.initNavbarImage();

                // Adding class show on the navbar-collapse for animation working properly
                $('.navbar-collapse').addClass('show');

                $navbar = $('.navbar[color-on-scroll]');
                scroll_distance = 50;
                // scroll_distance = $navbar.attr('color-on-scroll') || 500;

                // Check if we have the class "navbar-color-on-scroll" then add the function to remove the class "navbar-transparent" so it will transform to a plain color.
                if ($('.navbar[color-on-scroll]').length != 0) {
                    nowuiKit.checkScrollForTransparentNavbar();
                    $(window).on('scroll', nowuiKit.checkScrollForTransparentNavbar)
                }

                $('.form-control').on("focus", function() {
                    $(this).parent('.input-group').addClass("input-group-focus");
                }).on("blur", function() {
                    $(this).parent(".input-group").removeClass("input-group-focus");
                });

                // Activate bootstrapSwitch
                $('.bootstrap-switch').each(function() {
                    $this = $(this);
                    data_on_label = $this.data('on-label') || '';
                    data_off_label = $this.data('off-label') || '';

                    $this.bootstrapSwitch({
                        onText: data_on_label,
                        offText: data_off_label
                    });
                });

                if ($(window).width() >= 992) {
                    big_image = $('.page-header-image[data-parallax="true"]');

                    $(window).on('scroll', nowuiKit.checkScrollForParallax);
                }


            });

            $(window).on('resize', function() {
                nowuiKit.initNavbarImage();
            });

            $(document).on('click', '.navbar-toggler', function() {
                var $toggle, div;
                $toggle = $(this);
                console.log('should be toggling');
                if (nowuiKit.misc.navbar_menu_visible == 1) {
                    $('html').removeClass('nav-open');
                    nowuiKit.misc.navbar_menu_visible = 0;
                    $('#bodyClick').remove();
                    setTimeout(function() {
                        $toggle.removeClass('toggled');
                    }, 550);
                } else {
                    setTimeout(function() {
                        $toggle.addClass('toggled');
                    }, 580);
                    div = '<div id="bodyClick"></div>';
                    $(div).appendTo('body').click(function() {
                        $('html').removeClass('nav-open');
                        nowuiKit.misc.navbar_menu_visible = 0;
                        setTimeout(function() {
                            $toggle.removeClass('toggled');
                            $('#bodyClick').remove();
                        }, 550);
                    });

                    $('html').addClass('nav-open');
                    nowuiKit.misc.navbar_menu_visible = 1;
                }
            });


            nowuiKit = {
                misc: {
                    navbar_menu_visible: 0
                },

                checkScrollForTransparentNavbar: debounce(function() {
                    if ($(document).scrollTop() > scroll_distance) {
                        if (transparent) {
                            transparent = false;
                            $('.navbar[color-on-scroll]').removeClass('navbar-transparent');
                        }
                    } else {
                        if (!transparent) {
                            transparent = true;
                            $('.navbar[color-on-scroll]').addClass('navbar-transparent');
                        }
                    }
                }, 17),

                initNavbarImage: function() {
                    var $navbar = $('.navbar').find('.navbar-translate').siblings('.navbar-collapse');
                    var background_image = $navbar.data('nav-image');

                    if (background_image != undefined) {
                        if ($(window).width() < 991 || $('body').hasClass('burger-menu')) {
                            $navbar.css('background', "url('" + background_image + "')")
                                .removeAttr('data-nav-image')
                                .css('background-size', "cover")
                                .addClass('has-image');
                        } else {
                            $navbar.css('background', "")
                                .attr('data-nav-image', '' + background_image + '')
                                .css('background-size', "")
                                .removeClass('has-image');
                        }
                    }
                },


            }

            // Returns a function, that, as long as it continues to be invoked, will not
            // be triggered. The function will be called after it stops being called for
            // N milliseconds. If `immediate` is passed, trigger the function on the
            // leading edge, instead of the trailing.

            function debounce(func, wait, immediate) {
                var timeout;
                return function() {
                    var context = this,
                        args = arguments;
                    clearTimeout(timeout);
                    timeout = setTimeout(function() {
                        timeout = null;
                        if (!immediate) func.apply(context, args);
                    }, wait);
                    if (immediate && !timeout) func.apply(context, args);
                };
            };
        }

        initTheme();

    }

}

export default angular.module('hessApp.main', [uiRouter])
    .config(routing)
    .component('main', {
        template: require('./main.html'),
        controller: MainController
    })
    .name;



// WEBPACK FOOTER //
// ./client/app/main/main.component.js